import Et3ATag from "../../../core/et3-a-tag";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";
import { SURFACE_BORDER } from "../../../core/et3-theme/surface-constants";
import { FIELD_GRID_MONO_FONT_STACK } from "../../../core/et3-field-grid/field-grid-constants";
import {
  ID_PILL_FONT_SIZE,
  ID_PILL_HEIGHT,
  ID_PILL_PADDING,
  ID_PILL_RADIUS_CSS
} from "./approval-data-constants";

const ApprovalIdPill = withLiteObserverAndTheme<{ userId: number }>((props) => {
  const { userId, theme } = props;
  const { colors, unitX } = theme;

  return (
    <Et3ATag
      href={`/users/advanced?id=${userId}`}
      target="_blank"
      style={{ textDecoration: "none" }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={0}
        height={ID_PILL_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.paleGrayishWhite}
        style={{
          boxSizing: "border-box",
          width: "auto",
          flexShrink: 0,
          border: SURFACE_BORDER,
          borderRadius: ID_PILL_RADIUS_CSS,
          paddingLeft: ID_PILL_PADDING * unitX,
          paddingRight: ID_PILL_PADDING * unitX,
          cursor: "pointer"
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={ID_PILL_FONT_SIZE}
          text={`#${userId}`}
          isSpan={true}
          color={colors.all.bondiBlue}
          style={{ margin: 0, fontFamily: FIELD_GRID_MONO_FONT_STACK }}
        />
      </ET3Div>
    </Et3ATag>
  );
});
export default ApprovalIdPill;
